import React from 'react'
import { Field, FormSection, change } from 'redux-form'
import { useDispatch } from 'react-redux'
import { AutoCompleteSelect, Input, InputWithIcon } from '../../../../../../../../../../itrust_common/components/form'
import {
  B_MEASUREMENT_OPTIONS,
  BRIDGE_SIZE_OPTIONS,
  EYE_SIZE_OPTIONS,
  FRAME_EDGE_TYPE_OPTIONS,
  SPECTERA_CLAIM_FORM,
  TEMPLE_SIZE_OPTIONS,
} from './constants'

export default function SpecteraPatientFrameNotFoundSection(props = {}) {
  const { isLenses = true, disableBilledCharges } = props
  const isBilledDisabled = disableBilledCharges !== undefined ? disableBilledCharges : isLenses
  const dispatch = useDispatch()

  const handleClear = () => {
    const fields = [
      'manufacturer',
      'collection',
      'style',
      'color',
      'eye_size',
      'b_measurement',
      'bridge_size',
      'temple_size',
      'edge_type',
      'frame_bill_charges',
    ]
    fields.forEach((field) => {
      dispatch(change(SPECTERA_CLAIM_FORM, `lab_frame.${field}`, ''))
    })
  }

  return (
    <FormSection name="lab_frame">
      <div className="d-flex justify-content-between align-items-center mb-4 mt-2">
        <h5 className="mb-0">Patient Frame Not Found Information</h5>
        <button
          type="button"
          className="btn btn-link btn-sm p-0"
          onClick={handleClear}
        >
          Clear
        </button>
      </div>

      <div className="row">
        <Field
          name="manufacturer"
          label="Manufacturer"
          component={Input}
          className="form-control"
          wrapperClasses="form-group col-4"
        />
        <Field
          name="collection"
          label="Collection"
          component={Input}
          className="form-control"
          wrapperClasses="form-group col-4"
        />
        <Field
          name="style"
          label="Style"
          component={Input}
          className="form-control"
          wrapperClasses="form-group col-4"
        />
        <Field
          name="color"
          label="Color"
          component={Input}
          className="form-control"
          wrapperClasses="form-group col-4"
        />
        <Field
          name="eye_size"
          valueField="value"
          textField="value"
          label="Eye Size"
          component={AutoCompleteSelect}
          data={EYE_SIZE_OPTIONS}
          className="form-control"
          wrapperClasses="form-group col-4"
        />
        <Field
          name="b_measurement"
          label="B Measurement"
          valueField="value"
          textField="value"
          component={AutoCompleteSelect}
          data={B_MEASUREMENT_OPTIONS}
          className="form-control"
          wrapperClasses="form-group col-4"
        />
        <Field
          name="bridge_size"
          label="Bridge Size"
          valueField="value"
          textField="value"
          component={AutoCompleteSelect}
          data={BRIDGE_SIZE_OPTIONS}
          className="form-control"
          wrapperClasses="form-group col-4"
        />
        <Field
          name="temple_size"
          label="Temple Size"
          valueField="value"
          textField="value"
          component={AutoCompleteSelect}
          data={TEMPLE_SIZE_OPTIONS}
          className="form-control"
          wrapperClasses="form-group col-4"
        />
        <Field
          name="edge_type"
          label="Frame Edge Type"
          valueField="value"
          textField="value"
          component={AutoCompleteSelect}
          data={FRAME_EDGE_TYPE_OPTIONS}
          className="form-control"
          wrapperClasses="form-group col-4"
        />
        <Field
          name="frame_bill_charges"
          component={InputWithIcon}
          label="Billed Charges"
          title="$"
          className="form-control"
          wrapperClasses="form-group col-4"
          disabled={isBilledDisabled}
        />
      </div>
      <hr />
    </FormSection>
  )
}
